import React, { useMemo } from 'react';

import { NavigationContext } from '../../context/NavigationContext';
import { SearchContext } from '../../context/SearchContext';
import { useResponsiveSidebar } from '../../hooks/useResponsiveSidebar';
import { useSearch } from '../../hooks/useSearch';

export const Provider: React.FC = ({ children }) => {
  const { openSidebar, closeSidebar, open } = useResponsiveSidebar();
  const [searchOpen, openSearch, closeSearch] = useSearch();

  const searchContextValue = useMemo(
    () => ({ open: searchOpen, openSearch, closeSearch }),
    [searchOpen, openSearch, closeSearch],
  );
  const navigationContextValue = useMemo(
    () => ({
      open,
      closeNavigation: closeSidebar,
      openNavigation: openSidebar,
    }),
    [open, closeSidebar, openSidebar],
  );

  return (
    <SearchContext.Provider value={searchContextValue}>
      <NavigationContext.Provider value={navigationContextValue}>
        {children}
      </NavigationContext.Provider>
    </SearchContext.Provider>
  );
};
